const backBtnClass = "sales-swiper-prev";
const nextBtnClass = "sales-swiper-next";

let industryProductSwiper;
initSwiperAfterLibLoad(".sales-page-swiper", {
      // Optional parameters
      direction: "horizontal",
      shortSwipes: true,
      simulateTouch: true,
      slideToClickedSlide: false,
      slidesPerView: "auto",
      slidesPerGroupAuto: true,
      spaceBetween: 24,
      loop: false,
      speed: 500,
      autoHeight: true,
      effect: "slide",
      allowSlideNext: true,
      allowTouchMove: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      // Navigation arrows
      navigation: {
          prevEl: "." + backBtnClass,
          nextEl: "." + nextBtnClass,
      },
      on: {
      },
  }).then(result => industryProductSwiper = result);